var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 260,
    viewBox: "0 0 291 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.434 144.003C225.002 96.2552 273.298 113.442 290.75 128.003C288.567 46.1038 233.631 13.4365 206.436 7.34027C88.9575 -26.331 26.8221 63.7837 22.9235 116.628C18.4012 281.127 172.99 259.87 176.45 258.279C121.398 194.909 167.142 152.951 171.434 144.003Z",
    fill: "#F08B1F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_10771)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1623_10771)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8394 79.9042L37.0823 80.6039L54.917 90.6433L72.7517 80.6039L73.9946 79.9042L75.2374 80.6039L93.0722 90.6433L110.907 80.6039L112.15 79.9042L113.393 80.6039L131.227 90.6433L149.062 80.6039L151.548 85.0657L132.47 95.8048L131.227 96.5045L129.984 95.8048L112.15 85.7654L94.315 95.8048L93.0722 96.5045L91.8293 95.8048L73.9946 85.7654L56.1599 95.8048L54.917 96.5045L53.6742 95.8048L35.8394 85.7654L18.0047 95.8048L16.7618 96.5045L15.519 95.8048L-3.55859 85.0657L-1.07289 80.6039L16.7618 90.6433L34.5966 80.6039L35.8394 79.9042ZM35.8394 111.099L37.0823 111.798L54.917 121.838L72.7517 111.798L73.9946 111.099L75.2374 111.798L93.0722 121.838L110.907 111.798L112.15 111.099L113.393 111.798L131.227 121.838L149.062 111.798L151.548 116.26L132.47 126.999L131.227 127.699L129.984 126.999L112.15 116.96L94.315 126.999L93.0722 127.699L91.8293 126.999L73.9946 116.96L56.1599 126.999L54.917 127.699L53.6742 126.999L35.8394 116.96L18.0047 126.999L16.7618 127.699L15.519 126.999L-3.55859 116.26L-1.07289 111.798L16.7618 121.838L34.5966 111.798L35.8394 111.099ZM37.0823 142.993L35.8394 142.293L34.5966 142.993L16.7618 153.032L-1.07289 142.993L-3.55859 147.455L15.519 158.194L16.7618 158.894L18.0047 158.194L35.8394 148.154L53.6742 158.194L54.917 158.894L56.1599 158.194L73.9946 148.154L91.8293 158.194L93.0722 158.894L94.315 158.194L112.15 148.154L129.984 158.194L131.227 158.894L132.47 158.194L151.548 147.455L149.062 142.993L131.227 153.032L113.393 142.993L112.15 142.293L110.907 142.993L93.0722 153.032L75.2374 142.993L73.9946 142.293L72.7517 142.993L54.917 153.032L37.0823 142.993Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1623_10771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.903 168.327V170.967C177.908 171.57 177.733 172.161 177.401 172.664C177.069 173.168 176.594 173.561 176.038 173.793C175.678 173.938 175.295 174.015 174.907 174.019H120.252C119.644 174.021 119.049 173.84 118.545 173.5C118.041 173.159 117.651 172.674 117.426 172.109C117.28 171.732 117.207 171.331 117.212 170.927C124.237 170.927 126.645 166.049 131.732 166.049C137.124 166.049 138.26 170.221 143.075 170.221C147.891 170.221 153.249 161.99 160.597 161.99C167.645 161.962 168.588 168.106 177.903 168.327Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 80.4013H126V60.1864H131.37V80.4013Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 63.4312H134.998V77.1565H131.37V63.4312Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.733 80.4013H169.103V60.1864H163.733V80.4013Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.733 63.4312H160.105V77.1565H163.733V63.4312Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.648 141.792L127.736 122.007C125.646 119.762 124.506 116.795 124.555 113.729C124.604 110.662 125.837 107.733 127.997 105.556C130.157 103.379 133.076 102.122 136.142 102.05C139.208 101.977 142.182 103.094 144.443 105.167L147.512 108.219L150.564 105.15C151.646 103.979 152.953 103.039 154.406 102.385C155.859 101.73 157.429 101.375 159.023 101.341C160.616 101.307 162.2 101.594 163.68 102.185C165.16 102.776 166.506 103.659 167.637 104.781C168.769 105.904 169.663 107.243 170.266 108.718C170.869 110.194 171.168 111.776 171.147 113.369C171.125 114.963 170.783 116.536 170.141 117.995C169.498 119.454 168.568 120.768 167.407 121.86L147.648 141.792Z",
    fill: "#6158DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.805 43.5612C116.599 44.0039 116.53 44.4979 116.607 44.9801C116.678 45.4645 116.895 45.9159 117.229 46.2746C117.636 46.7558 118.212 47.0632 118.839 47.1341C119.466 47.2049 120.096 47.0339 120.601 46.6559C121.106 46.2779 121.447 45.7214 121.556 45.1001C121.664 44.4787 121.532 43.8393 121.185 43.3124C120.889 42.8236 120.432 42.4537 119.892 42.2669C119.352 42.08 118.764 42.0879 118.229 42.2893C117.605 42.5079 117.092 42.9653 116.805 43.5612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.993 184.946H117.149C115.986 184.949 114.834 184.722 113.758 184.279C112.681 183.833 111.702 183.18 110.876 182.357C110.052 181.533 109.399 180.553 108.955 179.476C108.51 178.398 108.283 177.243 108.287 176.077V164.206C106.436 164.745 104.547 165.139 102.635 165.387V176.755C102.638 180.572 104.155 184.232 106.853 186.931C109.551 189.63 113.209 191.149 117.025 191.153H175.241C176.76 191.154 178.265 190.855 179.669 190.275C181.073 189.694 182.349 188.842 183.423 187.768C184.498 186.694 185.351 185.419 185.933 184.015C186.515 182.612 186.815 181.107 186.816 179.587V176.105C186.812 178.45 185.877 180.696 184.217 182.352C182.558 184.007 180.309 184.937 177.965 184.935L177.993 184.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.488 170.232C144.488 170.517 144.406 170.795 144.251 171.035C144.091 171.271 143.865 171.456 143.601 171.566C143.404 171.646 143.192 171.681 142.98 171.67C142.768 171.659 142.561 171.601 142.374 171.5C142.187 171.4 142.024 171.26 141.897 171.089C141.77 170.919 141.682 170.723 141.64 170.514C141.586 170.236 141.616 169.948 141.724 169.685C141.833 169.423 142.015 169.198 142.25 169.039C142.488 168.88 142.767 168.796 143.053 168.796C143.433 168.798 143.798 168.948 144.07 169.214C144.203 169.348 144.309 169.507 144.381 169.681C144.452 169.856 144.489 170.043 144.488 170.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.173 166.043C133.173 166.329 133.089 166.608 132.93 166.846C132.771 167.081 132.547 167.266 132.286 167.377C132.021 167.484 131.732 167.511 131.452 167.455C131.173 167.399 130.916 167.262 130.714 167.061C130.513 166.86 130.378 166.604 130.324 166.326C130.268 166.047 130.296 165.758 130.403 165.495C130.512 165.231 130.697 165.007 130.935 164.85C131.151 164.698 131.405 164.609 131.669 164.592C131.933 164.575 132.196 164.632 132.43 164.755C132.664 164.878 132.859 165.064 132.994 165.291C133.129 165.518 133.199 165.779 133.196 166.043H133.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.038 161.962C162.035 162.245 161.95 162.522 161.791 162.758C161.633 162.994 161.409 163.177 161.147 163.286C160.885 163.395 160.596 163.425 160.318 163.371C160.039 163.318 159.782 163.183 159.579 162.985C159.38 162.781 159.245 162.524 159.189 162.244C159.139 162.044 159.132 161.835 159.169 161.633C159.207 161.43 159.288 161.237 159.406 161.068C159.525 160.899 159.678 160.758 159.856 160.654C160.034 160.55 160.233 160.485 160.438 160.464C160.644 160.444 160.851 160.468 161.046 160.535C161.241 160.602 161.42 160.71 161.57 160.852C161.719 160.994 161.836 161.167 161.913 161.358C161.99 161.55 162.025 161.755 162.015 161.962H162.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.652 148.949C104.505 148.513 106.425 148.446 108.304 148.751V141.899C106.479 142.736 103.986 143.793 102.652 144.347V148.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.696 35.5962C112.242 35.5932 110.802 35.877 109.458 36.4314C108.115 36.9857 106.893 37.7997 105.864 38.8268C104.835 39.8538 104.019 41.0737 103.462 42.4167C102.905 43.7597 102.618 45.1994 102.618 46.6533V127.1C104.429 126.443 106.344 126.116 108.27 126.133V44.4826C108.27 42.1307 109.202 39.8747 110.863 38.209C112.523 36.5432 114.775 35.6037 117.127 35.5962H113.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7551 91.2492V102.029",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1586 96.6478H59.3745",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.127 35.5962H113.696C112.063 35.5934 110.45 35.9524 108.972 36.6473C107.495 37.3422 106.189 38.3559 105.15 39.6155C103.535 41.5995 102.652 44.0782 102.646 46.6364V127.06",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.259 126.111V44.46C108.26 42.3994 108.973 40.4024 110.277 38.8071C111.108 37.8021 112.151 36.9932 113.331 36.4382C114.512 35.8831 115.8 35.5956 117.104 35.5962H177.976C179.139 35.5947 180.29 35.8227 181.364 36.2672C182.439 36.7116 183.415 37.3637 184.236 38.1861C185.058 39.0085 185.709 39.985 186.153 41.0597C186.597 42.1343 186.824 43.286 186.822 44.4487V176.117",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.652 148.949V144.37",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.844 176.1C186.846 177.263 186.617 178.416 186.172 179.491C185.731 180.567 185.08 181.543 184.256 182.363C183.435 183.188 182.459 183.841 181.384 184.285C180.309 184.73 179.156 184.956 177.993 184.952H117.149C115.986 184.957 114.833 184.731 113.758 184.285C112.68 183.841 111.7 183.188 110.876 182.363C110.051 181.538 109.398 180.558 108.954 179.48C108.508 178.405 108.282 177.252 108.287 176.088V164.217",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.652 165.399V176.767C102.655 180.583 104.172 184.243 106.87 186.942C109.568 189.642 113.226 191.16 117.042 191.165H175.258C176.777 191.165 178.282 190.867 179.686 190.286C181.09 189.705 182.366 188.853 183.441 187.779C184.515 186.705 185.368 185.43 185.95 184.027C186.532 182.623 186.832 181.118 186.833 179.599V176.117",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.259 141.899V148.751",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.713 174.85C208.17 170.944 205.632 167.875 204.931 166.433C199.635 155.579 203.993 142.866 201.478 129.293C198.601 113.782 201.048 94.9406 202.698 84.9349C204.507 77.8857 200.438 75.6698 196.323 78.0779C192.751 80.1582 187.579 87.5974 186.85 89.4855",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.714 174.85C208.17 170.944 205.632 167.875 204.931 166.433C199.635 155.58 203.993 142.866 201.478 129.293C201.141 127.476 200.877 125.614 200.676 123.725",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.629 74.2339C97.1299 71.6336 91.8565 71.4471 90.4548 75.2684C89.0023 79.2255 92.8569 86.009 102.629 93.6969",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.822 178.876V132.519",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.629 98.8524C99.9221 96.9417 94.3153 94.8954 92.2975 99.1916C90.5171 103.013 92.8627 111.391 102.629 119.084",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.629 171.459C97.4747 168.581 92.874 164.845 93.1792 159.299C93.7105 149.689 104.008 147.88 108.281 148.751C115.974 150.322 116.409 160.565 109.225 163.833C106.795 164.665 104.282 165.234 101.731 165.529",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.781 149.486C96.6834 147.338 93.7613 144.308 93.2639 139.474C92.2974 130 101.578 127.038 105.874 126.263C115.838 124.511 117.211 137.66 109.333 141.408C106.987 142.538 101.748 144.737 101.748 144.737",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.606 191.159C134.269 196.676 147.28 211.436 154.995 219.316",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.039 97.0887C178.037 96.2855 177.718 95.5155 177.151 94.9462C176.868 94.667 176.534 94.4444 176.168 94.2905C175.8 94.1391 175.406 94.0623 175.009 94.0644H120.094C119.491 94.0593 118.9 94.2341 118.397 94.5663C117.893 94.8986 117.501 95.3733 117.268 95.9298C117.12 96.2983 117.043 96.6916 117.042 97.0887V144.132C117.043 144.529 117.12 144.923 117.268 145.291C117.498 145.85 117.89 146.326 118.394 146.659C118.898 146.991 119.49 147.165 120.094 147.157H174.986C175.59 147.162 176.18 146.987 176.684 146.655C177.187 146.322 177.58 145.848 177.812 145.291C177.961 144.923 178.037 144.529 178.039 144.132V97.0887Z",
    fill: "#F08B1F",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.234 83.3634C117.236 84.1665 117.555 84.9364 118.123 85.5043C118.691 86.0722 119.461 86.3919 120.264 86.3934H174.862C175.261 86.3941 175.656 86.3163 176.024 86.1645C176.393 86.0126 176.728 85.7896 177.01 85.5083C177.292 85.2269 177.516 84.8927 177.67 84.5247C177.823 84.1566 177.902 83.762 177.903 83.3634V57.2243C177.902 56.8247 177.824 56.4291 177.671 56.0598C177.521 55.693 177.298 55.3604 177.016 55.0818C176.734 54.7991 176.4 54.5744 176.032 54.4205C175.673 54.2758 175.289 54.1991 174.902 54.1943H120.252C119.865 54.1991 119.481 54.2758 119.122 54.4205C118.754 54.5744 118.42 54.7991 118.138 55.0818C117.836 55.355 117.593 55.688 117.426 56.0598C117.274 56.4291 117.195 56.8247 117.195 57.2243V83.3634H117.234Z",
    fill: "#F08B1F",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.234 170.967C117.236 171.77 117.555 172.54 118.121 173.109C118.405 173.388 118.738 173.611 119.105 173.765C119.473 173.916 119.866 173.993 120.264 173.991H174.862C175.25 173.989 175.634 173.912 175.992 173.765C176.359 173.611 176.693 173.388 176.976 173.109C177.543 172.54 177.861 171.77 177.863 170.967V157.965C177.863 157.565 177.785 157.17 177.632 156.8C177.481 156.434 177.258 156.101 176.976 155.823C176.695 155.54 176.36 155.315 175.992 155.161C175.633 155.016 175.25 154.94 174.862 154.935H120.252C119.865 154.94 119.481 155.016 119.122 155.161C118.754 155.315 118.42 155.54 118.138 155.823C117.856 156.101 117.633 156.434 117.483 156.8C117.33 157.17 117.251 157.565 117.251 157.965V170.967H117.234Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 80.4013H126V60.1864H131.37V80.4013Z",
    fill: "#6158DB",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 63.4312H134.998V77.1565H131.37",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.733 80.4013H169.103V60.1864H163.733V80.4013Z",
    fill: "#6158DB",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.733 63.4312H160.105V77.1565H163.733",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.999 68.7563H160.105",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.999 71.8484H160.105",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.57 105.167L147.54 108.219L144.471 105.167C142.216 103.059 139.229 101.912 136.143 101.97C133.057 102.028 130.115 103.287 127.941 105.478C125.767 107.669 124.532 110.621 124.498 113.708C124.464 116.795 125.633 119.774 127.758 122.012L147.67 141.798L167.452 121.882C168.555 120.776 169.428 119.464 170.022 118.019C170.616 116.575 170.92 115.028 170.915 113.466C170.91 111.904 170.598 110.359 169.995 108.918C169.392 107.478 168.511 106.17 167.402 105.071C166.291 103.973 164.975 103.104 163.529 102.516C162.082 101.927 160.534 101.63 158.972 101.641C157.411 101.652 155.867 101.971 154.429 102.58C152.991 103.189 151.687 104.076 150.592 105.189L150.57 105.167Z",
    fill: "#6158DB",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.234 170.899C124.26 170.899 126.662 166.026 131.754 166.026C137.146 166.026 138.282 170.192 143.092 170.192C147.902 170.192 153.266 161.962 160.613 161.962C167.661 161.962 168.605 168.106 177.909 168.321",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.759 131.933L221.186 146.574H233.129L226.555 161.21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.191 30.5425H196.379",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.857 30.5086H208.062",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.115 22.5945V26.8059",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.127 34.2565V38.4679",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.492 24.9348L197.476 27.9026",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.772 33.1655L205.756 36.1276",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.722 24.9122L202.772 27.9026",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.498 33.1824L194.514 36.1615",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.128 181.617L222.441 171.719C220.27 168.892 202.404 179.13 182.555 194.528C162.705 209.927 148.388 224.686 150.553 227.502L158.234 237.405",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.436 196.292C168.436 196.292 168.006 194.398 167.56 191.159",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_10771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 135,
    fill: "white",
    transform: "translate(0.75 44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1623_10771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.053,
    height: 135,
    fill: "white",
    transform: "translate(0.75 44)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1623_10771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.602,
    height: 215.659,
    fill: "white",
    transform: "translate(58.9507 22.1705)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome3);
export default __webpack_public_path__ + "static/media/welcome3.091c0df92dfdee914e7a884b4152309f.svg";
export { ForwardRef as ReactComponent };